import request from "./request";

function convertBase64ToFile (dataurl, filename) {
    try {
        var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        var file = new Blob([u8arr], { type: mime });
        file = new File([file], filename, {type: mime});

        return file;
    } catch (ex) {
        return null;
    }
}

async function uploadFile(base64String, filename) {
    try {
        const blob = convertBase64ToFile(base64String, filename);

        const formData = new FormData();
        formData.append('file', blob, filename);
        const response = await request.post(`${window.base_url}/api_v3/files`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })

        return response.data ? response.data: null;
    } catch (e) {
        console.error(e);
        return null;
    }
}

function isBase64Url(base64String) {
    const regex = /^data:(.*);base64,[a-zA-Z0-9+/]+=*$/;
    return regex.test(base64String)
}

function getFileUrl(url) {
    try {
        const parsedUrl = new URL(url);
        return `${window.base_url.replace(window.webroot, '')}${parsedUrl.pathname}${parsedUrl.search}`;
    } catch (e) {
        console.error(e);
        return url;
    }
}

async function imageUrlToBase64(imageUrl) {
    try {
        const response = await fetch(getFileUrl(imageUrl), {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'image/jpeg'
            }
        });
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (e) {
        console.error(e);
        return null;
    }
}

export { uploadFile, isBase64Url, getFileUrl, imageUrlToBase64, convertBase64ToFile };